import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { getAdminUserData } from '../../services/AdminUsers';
import MyTabsNested from '../../components/MyTabsNested';
import GeneralAdminUser from './GeneralAdminUser';
import AdminUser from './AdminUser';
import { useDispatch } from 'react-redux';
import { setPreview } from '../../redux/actions/previewActions';

const EditAdminUserRecord = () => {
  const { id } = useParams();
  const [adminUserTitle, setAdminUserTitle] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general",
      title: "General",
      Component: GeneralAdminUser,
      subTabs: [
        { id: "basic", title: "Basic", Component: AdminUser }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (id) {
          const result = await getAdminUserData(id);
          if (result) {
            const user = Array.isArray(result) ? result[0] : result;
            setAdminUserTitle(user?.username || '');
          }
        }
      } catch (error) {
        console.error('Error fetching admin user data:', error);
      }
    };

    getBasicData();
    dispatch(setPreview(false));
  }, [id, dispatch]);

  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && id) {
      navigate(`/admin-users/${id}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
    }
  }, [location.pathname, id, navigate, tabs]);

  return (
    <Stack py="5px">
      <Box px="4" pb="4">
        <Text fontSize={"22px"} fontWeight={"600"}>
          {id ? _.capitalize(adminUserTitle) : "New Admin User"}
        </Text>
      </Box>
      <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/admin-users"} />
    </Stack>
  );
};

export default EditAdminUserRecord;
